import {useState} from 'react';
import {useToggleI} from 'js/reusable/hooks/types';

const useToggle: useToggleI = function (initial) {
	const [state, setState] = useState(initial);

	function toggle() {
		setState(curr => !curr);
	}

	return [state, toggle];
};

export default useToggle;
